import { useState } from "react";

const faqs = [
  {
    question: "What services do you offer?",
    answer:
      "We provide web development, app development, UI/UX design, software solutions, home services, and real estate solutions.",
  },
  {
    question: "How experienced is your team?",
    answer:
      "Our team has 7 years of experience in building scalable and modern applications for clients worldwide.",
  },
  {
    question: "Do you offer support after delivery?",
    answer:
      "Yes, we provide ongoing support and maintenance to ensure your systems run smoothly.",
  },
  {
    question: "Can you handle custom projects?",
    answer:
      "Absolutely! We specialize in custom solutions tailored to your business needs.",
  },
  {
    question: "What is your pricing model?",
    answer:
      "We offer competitive pricing based on the project scope and requirements, with transparent estimates.",
  },
];

export default function WhyChooseUs() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="bg-gray-50 py-12 px-6 md:px-12">
      <div className="flex flex-col md:flex-row gap-10 items-start">
        {/* Left Side */}
        <div className="md:w-5/12">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">
            Why Choose X7 Group?
          </h2><br></br>
          <p className="text-gray-600 leading-relaxed text-lg">
            At X7, we’re dedicated to delivering high-quality solutions tailored to your business needs. Our expert team blends creativity, technology, and commitment to drive your growth and success in the digital era
          </p>
        </div>

        {/* Right Side - FAQ */}
        <div className="md:w-7/12">
          <div className="divide-y divide-gray-300">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="py-4 cursor-pointer"
                onClick={() => toggleFAQ(index)}
              >
                <div className="flex justify-between items-center">
                  <h3 className="text-lg font-medium text-gray-900">
                    {faq.question}
                  </h3>
                  <span className="text-2xl font-bold text-gray-700">
                    {activeIndex === index ? "−" : "+"}
                  </span>
                </div>
                {activeIndex === index && (
                  <p className="mt-2 text-gray-600">{faq.answer}</p>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
